// @flow

import { createSelector } from 'reselect';

import { FRIEND_GROUP_ID } from '../../constants/friendConstants';
import t from '../../utils/translate';

const friendGroup: FriendGroup = {
  id: FRIEND_GROUP_ID,
  name: t('My Friends'),
  members: []
};

function getGroups(groups: Object = {}) {
  return [friendGroup, ...Object.values(groups)];
}

export default createSelector(
  (state: GlobalState) => state.friendGroups.groups,
  getGroups
);
